import { render, staticRenderFns } from "./TourDetailsDates.vue?vue&type=template&id=3f54f606&scoped=true"
import script from "./TourDetailsDates.vue?vue&type=script&lang=js"
export * from "./TourDetailsDates.vue?vue&type=script&lang=js"
import style0 from "./TourDetailsDates.vue?vue&type=style&index=0&id=3f54f606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f54f606",
  null
  
)

export default component.exports